export const createWebSocketAuthLifecycle = ({ baseDelay, maxDelay }) => {
  let reconnectAttempts = 0;
  let hasAuthenticatedBefore = false;
  let reconnectBlocked = false;

  return {
    canReconnect() {
      return !reconnectBlocked;
    },
    authenticationRejected() {
      reconnectBlocked = true;
    },
    isAuthenticated() {
      return hasAuthenticatedBefore && reconnectAttempts === 0;
    },
    authenticated() {
      const shouldResync = hasAuthenticatedBefore;
      hasAuthenticatedBefore = true;
      reconnectAttempts = 0;
      reconnectBlocked = false;
      return { shouldResync };
    },
    closed() {
      const delay = Math.min(baseDelay * Math.pow(2, reconnectAttempts), maxDelay);
      reconnectAttempts += 1;
      return delay;
    },
  };
};
